var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"tw-flex tw-gap-2 tw-items-center tw-font-bold tw-py-2"},[_c('v-chip',{attrs:{"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.number)+" ")]),_c('span',[_vm._v(_vm._s(_vm.title))])],1),(_vm.divider)?_c('v-divider'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }